import SiteWrapper from 'components/SiteWrapper/SiteWrapper';
import React from 'react';
import InformationPage from '../../../../components/InformationPage/InformationPage';
import { useSelector } from 'react-redux';

const Info = () => {
    const IsLateEntry = useSelector(({ Home }) => Home.IsLateEntry);

    return (
        <SiteWrapper
            headerText="Information"
            goBack={IsLateEntry ? 'lateEntryHome' : 'home'}
        >
            <InformationPage />
        </SiteWrapper>
    );
};

export default Info;
